import React, { useMemo } from 'react';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import Select from 'react-select';
import 'prismjs/components/prism-markup-templating';

import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-liquid';

import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css'; //Example style, you can use another
import { parseJSON } from 'helpers/sf_utils';
import { useEffect } from 'react';
import { Liquid } from 'liquidjs'
import { Col, DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Row, UncontrolledDropdown } from 'reactstrap';
import { Card } from "reactstrap";
import FormattersModal from 'components/Common/Modals/FormattersModal';
import { useState } from 'react';
import { generateCodeSnippet, LEAD_INTEGRATION_CODE_SNIPPET_TYPES, SAMPLE_LEAD_JSON_1 } from 'helpers/sf_integeration_helper';
import { useRef } from 'react';
import MappingsModal from 'components/Common/Modals/MappingsModal';
import { API_FIELDS_TYPES_FOR_INTEGRATIONS, EDITOR_CLASS_NAME } from 'helpers/sf_constants';
import beautify from "xml-beautifier";
import _ from 'lodash';
import qs from "qs"
import CodePreview from 'components/Common/CodePreview/CodePreview';
import { AppConfiguration } from 'config';
import LeadMacrosTable from 'components/payload_editor/LeadMacrosTable';
import LabelWithTooltip from 'components/Common/LabelWithTooltip';

const TOOLTIP_CONSTANTS = {
    MACRO_KEY: {
        ID: "api_fields_tooltip_macro_key",
        NAME: "Macro Key",
        TOOLTIP_MESSAGE: "List of available marcos that can be added to your payload"
    }
}

export const PayloadEditor = ({ req_payload_type, parsedCode, updateParsedCode, sf_lead_integration_macros, sf_lead_integration_macro_categories, macroMappingState, updateMacroMapped, sample_leads, lead_type_id, productSpecificSampleLeadsEnabled, productOptions, selectedProductType, onSelectedProductTypeChange, readOnly = false }) => {
    const textareaRef = useRef();
    const [openAccordionState, setOpenAccordionState] = useState([]);
    const [selfParsedCode, setSelfParsedCode] = useState("")
    const [codeState, setCodeState] = React.useState(parsedCode);
    const [formatterModal, setFormatterModal] = useState(false)
    const [mappingModal, setMappingModal] = useState({ active: false, macro: null });
    const [error, setError] = React.useState(null);
    const [selectedMacro, setSelectedMacro] = React.useState(null);
    const [cursorPositionX, setCursorPositionX] = React.useState(0);
    const [cursorPositionY, setCursorPositionY] = React.useState(0);
    const [selectedSampleLead, setSelectedSampleLead] = useState(null);
    const [macroSearchText, setMacroSearchText] = useState('');

    const code = useMemo(() => {
        return codeState || '';
    }, [codeState]);


    const recursive_flatten_sf_categories = (categories) => {
        let flattened_categories = []
        categories.forEach(category => {
            flattened_categories = [...flattened_categories, category]
            if (category?.sub_categories) {
                flattened_categories = [...flattened_categories, ...recursive_flatten_sf_categories(category?.sub_categories)]
            }
        })

        return flattened_categories
    }

    const flattened_categories = useMemo(() => recursive_flatten_sf_categories(sf_lead_integration_macro_categories), [sf_lead_integration_macro_categories])

    useEffect(() => {
        setOpenAccordionState(flattened_categories?.map((category, index) => ({ id: category.id, active: index === 0 ? true : false })))
    }, [flattened_categories]);


    useEffect(() => {
        const matchedSampleLead = productSpecificSampleLeadsEnabled
            ? sample_leads?.find(ssl => ssl.lead_type_id === lead_type_id && ssl.product_type_id === selectedProductType?.value)
            : null
        const sample_lead = (matchedSampleLead || sample_leads?.find(ssl => ssl.lead_type_id === lead_type_id))?.mapped_variables || null
        setSelectedSampleLead(sample_lead);
    }, [sample_leads, lead_type_id, productSpecificSampleLeadsEnabled, selectedProductType?.value])

    const convertToXml = (obj) => {
        let xml = "";
        for (const key in obj) {
            if (typeof obj[key] === "object") {
                xml += `<${key}>`;
                xml += convertToXml(obj[key]);
                xml += `</${key}>`;
            } else {
                xml += `<${key}>${obj[key]}</${key}>`;
            }
        }
        return xml;
    };

    useEffect(() => {
        setCodeState(parsedCode)
    }, [parsedCode])

    const jsonToSoap = (obj) => {
        let xml = `<?xml version="1.0" encoding="utf-8"?>
        <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
            <soap:Body>
                ${convertToXml(obj)}
            </soap:Body>
        </soap:Envelope>`
        return xml;
    }

    const jsonToHttp = (obj) => {
        try {
            return qs.stringify(obj)
        } catch (error) {
            return error
        }
    }

    const insertCode = (new_code) => {
        const selectionStart = textareaRef.current._input.selectionStart;
        const selectionEnd = textareaRef.current._input.selectionEnd;

        let newValue =
            code.substring(0, selectionStart) +
            new_code +
            code.substring(selectionEnd, code.length);
        setCodeState(newValue);
    };
    //Open Tools dropdown
    const [showTools, setShowTools] = useState(false);

    const openTools = () => {
        setShowTools(!showTools)
    }

    function getLineNumberAndColumnIndex(textarea) {
        var textLines = textarea.value.substr(0, textarea.selectionStart).split("\n");
        var currentLineNumber = textLines.length;
        var currentColumnIndex = textLines[textLines.length - 1].length;
        setCursorPositionX(currentColumnIndex)
        setCursorPositionY(currentLineNumber)
    }

    const duplicateMacrosMapping = (row) => {
        // getMaxCopyIndex
        // macro keys matching "key_copy_<some number>"
        const re = new RegExp(`^${row?.key}_copy_\\d+$`)
        const reTillCopy = new RegExp(`^${row?.key}_copy_`)
        const max_copy_index = macroMappingState
            .map(macro => macro?.key)
            // filter out keys which don't match regex
            .filter(macro_key => macro_key?.search(re) !== -1)
            // Get the max index
            .reduce((accum, cur) => _.max([parseInt(cur.replace(reTillCopy, '')), accum]), 0)
        let unique_key = `${row?.key}_copy_${max_copy_index + 1}`
        let unique_display_key = `${row?.display_key} (Copy ${max_copy_index + 1})`

        const data = {
            ...row,
            key: unique_key,
            display_key: unique_display_key,
            is_custom_mapping_active: false,
            // omit the macro mapping output values and id
            lead_integration_macro_mappings: (row.lead_integration_macro_mappings || [])
                .map(mapping => (_.omit({ ...mapping, output_value: '' }, ['id'])))
        }
        updateMacroMapped([_.omit(data, ['id'])], true)
    }

    const checked_stats_by_keys = useMemo(() => {
        const mached_state_keys = []
        // Extract the variable names from the template
        const matches = (code || '').match(/{{\s*(\w+\.?\w*)\s*|\|\s*}}/g);

        matches?.forEach((match) => {
            const variable = match.replace(/{{\s*(\w+\.?\w*)\s*|\|\s*}}/, "$1");
            const var_arr = variable.split(".")
            const last_var = var_arr[var_arr.length - 1]
            mached_state_keys.push(last_var)
        });
        return mached_state_keys
    }, [code]);

    const engine = new Liquid();

    const parseLiquidTemplate = (template) => {
        try {
            setError(null)
            const output = engine.parseAndRenderSync(template, selectedSampleLead);
            return output;
        } catch (error) {
            setError(error)
        }
    }

    const parseJSON_Copy = (jsonString) => {
        try {
            const jsonObject = JSON.parse(jsonString);
            return jsonObject;
        } catch (error) {
            setError(error)
            return '';
        }
    }

    const getParsedCode = (req_type, code) => {
        //Preprocess any liquid code
        //Convert JSON to XML
        switch (req_type) {
            case API_FIELDS_TYPES_FOR_INTEGRATIONS.JSON:
                return JSON.stringify(parseJSON(code), null, 2)
            case API_FIELDS_TYPES_FOR_INTEGRATIONS.XML:
                return beautify(convertToXml(JSON.parse(code)))
            case API_FIELDS_TYPES_FOR_INTEGRATIONS.HTTP:
                return jsonToHttp(JSON.parse(code))
            case API_FIELDS_TYPES_FOR_INTEGRATIONS.SOAP:
                return beautify(jsonToSoap(JSON.parse(code)))
            default:
                return code
        }

    }

    useEffect(() => {
        try {
            //const tpl = engine.parseAndRenderSync(code)
            const tpl = parseLiquidTemplate(code)
            setError(null)
            updateParsedCode(code)
            //setSelfParsedCode(tpl)
            setSelfParsedCode(getParsedCode(req_payload_type, tpl))
        } catch (e) {
            setError(e)
        }
    }, [code, req_payload_type, selectedSampleLead])

    const launchFormatterModal = (macro) => {
        setSelectedMacro(macro?.key)
        setFormatterModal(true);
    };

    const launchMappingModal = (macro_obj) => {
        setMappingModal({ active: true, macro: macro_obj });
    }

    const onSubmitMacroMappingState = (macro_mapped) => {
        updateMacroMapped([macro_mapped], false)
        setMappingModal({ active: false, macro: null })
    }

    const OnGenerateCode = (snippet_type, selectedMacro) => {
        let code_snippet = generateCodeSnippet(snippet_type, selectedMacro)
        insertCode(code_snippet)
    }

    // returns an array of sf lead integration macro categories with
    // lead_integration_macros for each category and specific to a lead_type_id
    const getLeadIntegrationMacroCategories = (sf_macro_categories, li_macros, searchText) => {
        const macroHasText = (macro, searchText) => {
            return macro.key.toLowerCase().includes(searchText) || macro.display_key.toLowerCase().includes(searchText);
        }

        return sf_macro_categories
            .map(category => {
                let has_matched_category = false;
                if (category.name.toLowerCase().includes(searchText)) {
                    has_matched_category = true;
                }

                return {
                    ...category,
                    // get the lead_integration_macros for each sf_macro
                    lead_integration_macros: _.flatten(
                        category.sf_lead_integration_macros
                            .map(sf_macro => li_macros
                                .filter(li_macro => li_macro.sf_lead_integration_macro_id === sf_macro.id && (has_matched_category || macroHasText(li_macro, searchText))))
                    ),
                    sub_categories: category?.sub_categories?.length ? getLeadIntegrationMacroCategories(category.sub_categories, li_macros, searchText) : []
                }
            })
            .filter(category => category.lead_integration_macros.length || category.sub_categories.length)
    }

    const macroCategoriesTableData = useMemo(() => {
        return getLeadIntegrationMacroCategories(sf_lead_integration_macro_categories || [], macroMappingState || [], macroSearchText.toLowerCase())
    }, [sf_lead_integration_macro_categories, macroMappingState, macroSearchText]);

    return (
        <>
            <FormattersModal
                onAddClick={(formatted_text) => {
                    insertCode(formatted_text)
                    setFormatterModal(false)
                }}
                onCloseClick={() => setFormatterModal(false)}
                show={formatterModal}
                macro={selectedMacro}
                title='Formatter'
            />
            <MappingsModal
                onAddClick={onSubmitMacroMappingState}
                onCloseClick={() => setMappingModal({ active: false, macro: null })}
                show={mappingModal}
                title='Mapping'
            />
            <span>{AppConfiguration.WEBSITE} uses Liquid for helping you write your integrations.
                <a className='text-sfblue' target='_blank' href='https://shopify.github.io/liquid/'> You can refer to the documentation here</a>
            </span>
            {!readOnly && <div className='d-flex mt-2'>
                <a className='text-sfblue' onClick={() => { setCodeState(SAMPLE_LEAD_JSON_1) }}> <i className='bx bx-plus  align-middle font-weight-semibold' /><span className="ms-1 align-middle">Start with a sample Lead </span></a>
                <div className='ms-4'>
                    <UncontrolledDropdown isOpen={(showTools)}>
                        <DropdownToggle onClick={() => openTools()} className="card-drop fsnormal" tag="i">
                            <a className='text-sfblue'>
                                <i className='bx bx-plus align-middle font-weight-semibold' /><span className="align-middle"> Add If, For & Range</span>
                            </a>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-start">
                            <DropdownItem text>
                                <div className="float-end">
                                    <div className="close" style={{ cursor: "pointer" }} onClick={() => openTools()} id="edit-adgroup-info-close"><span aria-hidden="true">&times;</span></div>
                                </div>
                            </DropdownItem>
                            <DropdownItem
                                onClick={() => OnGenerateCode(LEAD_INTEGRATION_CODE_SNIPPET_TYPES.IF_ELSE, selectedMacro)}
                            >
                                If
                            </DropdownItem>
                            <DropdownItem onClick={() => OnGenerateCode(LEAD_INTEGRATION_CODE_SNIPPET_TYPES.FOR_LOOP, selectedMacro)}>For</DropdownItem>
                            <DropdownItem onClick={() => OnGenerateCode(LEAD_INTEGRATION_CODE_SNIPPET_TYPES.FOR_LOOP, selectedMacro)}>Range</DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </div>}

            <Row className='mt-3'>
                <Col md={3}>
                    <LabelWithTooltip name={TOOLTIP_CONSTANTS.MACRO_KEY.NAME} tooltip_message={TOOLTIP_CONSTANTS.MACRO_KEY.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS.MACRO_KEY.ID} htmlFor="macro_key" />
                    <Card className="p-2 pt-0 sf-scrollbar border" id='lead-integration-macro-key' style={{ maxHeight: "584px", overflowY: "scroll", border: "1px solid gray" }}>
                        <div className="search-bar-container">
                            <div className="search-box d-inline-block">
                                <div className="position-relative">
                                    <Input type="text" value={macroSearchText} onChange={(e) => setMacroSearchText(e.target.value)} placeholder="Search" className="rounded" />
                                    <i className="bx bx-search-alt search-icon" />
                                </div>
                            </div>
                        </div>
                        <div className="accordion border-0" id="integrations-macros">
                            {macroCategoriesTableData && macroCategoriesTableData.map((category, index) => {
                                return (
                                    <LeadMacrosTable
                                        index={index}
                                        key={index}
                                        lastIndex={macroCategoriesTableData.length - 1 === index}
                                        category={category}
                                        checked_macro_Key_stats={checked_stats_by_keys}
                                        openAccordionState={openAccordionState}
                                        setOpenAccordionState={setOpenAccordionState}
                                        launchFormatterModal={launchFormatterModal}
                                        launchMappingModal={launchMappingModal}
                                        duplicateMacrosMapping={duplicateMacrosMapping}
                                        readOnly={readOnly}
                                    />
                                )
                            })}
                        </div>
                    </Card>
                </Col>

                <Col md={5}>
                    <Label className='mb-2 font-weight-semibold'>Editor</Label>
                    <div className="sf-scrollbar border" style={{ maxHeight: "584px", overflowY:"scroll", overflowX: "hidden" }}>
                        <Editor
                            value={code}
                            onValueChange={code1 => {
                                getLineNumberAndColumnIndex(textareaRef.current._input)
                                setCodeState(code1)
                            }}
                            highlight={code => {
                                return highlight(code, languages.liquid)
                                    .split("\n")
                                    .map((line, i) => `<span ${EDITOR_CLASS_NAME}>${i + 1}</span>${line}`)
                                    .join("\n");
                            }
                            }
                            textareaId="codeArea"
                            readOnly={readOnly}

                            padding={10}
                            style={{
                                fontFamily: '"Courier New", Courier, monospace',
                                fontSize: 14,
                                outline: 0,
                                backgroundColor: '#FFFFFF',
                                minHeight: '584px'
                            }}
                            className="editor"
                            ref={textareaRef}


                        />
                    </div>
                </Col>

                <Col md={4}>
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                        <Label className='mb-0 font-weight-semibold'>Sample Payload</Label>
                        {productSpecificSampleLeadsEnabled && (
                            <div style={{ minWidth: '160px' }}>
                                <Select
                                    options={productOptions}
                                    classNamePrefix="select2-selection"
                                    onChange={onSelectedProductTypeChange}
                                    value={selectedProductType}
                                />
                            </div>
                        )}
                    </div>
                    <div className="sf-scrollbar border" style={{ maxHeight: "584px", overflowY: "scroll", overflowX: "hidden" }}>
                        {error ? <CodePreview code={error.message} color="red" /> :  <CodePreview code={selfParsedCode} />
                        }
                    </div>
                </Col>
            </Row>
        </>
    );
}
